import { render, staticRenderFns } from "./searchUser.vue?vue&type=template&id=4a351010&scoped=true&"
import script from "./searchUser.vue?vue&type=script&lang=ts&"
export * from "./searchUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a351010",
  null
  
)

export default component.exports